var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/24px/Camera",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,3 C17.5128358,3 17.9355072,3.38604019 17.9932723,3.88337887 L18,4 C18,4.55228475 18.4477153,5 19,5 L22,5 C23.1045695,5 24,5.8954305 24,7 L24,19 C24,20.1045695 23.1045695,21 22,21 L2,21 C0.8954305,21 0,20.1045695 0,19 L0,7 C0,5.8954305 0.8954305,5 2,5 L5,5 C5.51283584,5 5.93550716,4.61395981 5.99327227,4.11662113 L6,4 C6,3.44771525 6.44771525,3 7,3 L17,3 Z M12,7 C8.6862915,7 6,9.6862915 6,13 C6,16.3137085 8.6862915,19 12,19 C15.3137085,19 18,16.3137085 18,13 C18,9.6862915 15.3137085,7 12,7 Z M12,8 C14.7614237,8 17,10.2385763 17,13 C17,15.7614237 14.7614237,18 12,18 C9.23857625,18 7,15.7614237 7,13 C7,10.2385763 9.23857625,8 12,8 Z M20,8 C19.4477153,8 19,8.44771525 19,9 C19,9.55228475 19.4477153,10 20,10 C20.5522847,10 21,9.55228475 21,9 C21,8.44771525 20.5522847,8 20,8 Z",
    id: "Shape",
    fill: "#EFEFF0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.8cc3c37e52e5f5b071424aac3f37e146.svg";
export { ForwardRef as ReactComponent };